import { NgModule, ErrorHandler, Injectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { AppTranslate, HttpLoaderFactory } from './app.translate';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule } from 'angular2-toaster';

import { AppComponent } from './app.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NAV_DROPDOWN_DIRECTIVES } from './shared/nav-dropdown.directive';

import { ChartsModule } from 'ng2-charts/ng2-charts';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './shared/sidebar.directive';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation'
import { BsDatepickerModule } from 'ngx-bootstrap';

// Routing Module
import { AppRoutingModule } from './app.routing';

// Services
import { SettingsService } from './services/settings.service';
import { CalendarRefreshService } from './services/calendar-refresh.service';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';

import { MomentModule } from 'angular2-moment';
import { AuthenticationService } from './services/authentication.service';
import { BlankLayoutComponent } from './layouts/blank-layout.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CalendarModule } from 'angular-calendar';

import { SENTRY_DSN } from './app.service';
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: SENTRY_DSN
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
  }

  handleError(error) {
    Sentry.captureException(error.originalError || error);
  }
}

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    CustomFormsModule,
    BrowserAnimationsModule,
    ToasterModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    BsDatepickerModule.forRoot(),
    MomentModule,
    FontAwesomeModule,
    CalendarModule.forRoot()
  ],
  declarations: [
    AppComponent,
    FullLayoutComponent,
    BlankLayoutComponent,
    NAV_DROPDOWN_DIRECTIVES,
    BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
  ],
  providers: [
    GoogleAnalyticsEventsService,
    AuthenticationService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    },
    SettingsService,
    CalendarRefreshService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends AppTranslate {

  constructor(translate: TranslateService) {
    super(translate);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts